// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";

import { ISearchFormProps } from "./common";

// ---------------------------------------------- the component
const SearchForm: FunctionComponent<ISearchFormProps> = ({
  criteria,
  onFilter
}) => {
  // ---------------------------------------------- handlers
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => e.preventDefault();

  const handleChange = (
    e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>
  ) => onFilter(e.currentTarget.name, e.currentTarget.value);

  // ---------------------------------------------- effects
  useEffect(() => {
    const selects = document.querySelectorAll("select");

    M.FormSelect.init(selects);
  }, []);

  // ---------------------------------------------- content
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="input-field col s12 m3" style={{ marginBottom: "0px" }}>
          <select
            id="prop"
            name="prop"
            defaultValue={criteria.prop}
            onChange={handleChange}
          >
            <option value="name">Name</option>

            <option value="creator">Creator</option>
          </select>

          <label htmlFor="prop">find by</label>
        </div>

        <div className="input-field col s12 m9" style={{ marginBottom: "0px" }}>
          <i className="material-icons prefix">search</i>

          <input
            type="text"
            id="keywords"
            name="keywords"
            autoComplete="off"
            onChange={handleChange}
            required
          />

          <label htmlFor="keywords">your keywords</label>
        </div>
      </div>
    </form>
  );
};

export default SearchForm;
